var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}


$().ready(function(){
  $('.slider-testi').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    arrows: true,
    infinite: true,
    prevArrow: '<svg class="slick-prev slick-arrow" width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M58 58V1H1V58H58Z" stroke="#161616" stroke-width="2"/><path d="M25.5 29L31.6829 22.7975C31.7868 22.7015 31.9239 22.6496 32.0652 22.6525C32.2066 22.6554 32.3414 22.7129 32.4413 22.8131C32.5412 22.9132 32.5984 23.0481 32.6009 23.1895C32.6035 23.3309 32.5511 23.4678 32.4549 23.5715L26.3209 29.6885L32.4579 35.8045C32.5541 35.9081 32.6065 36.045 32.6039 36.1864C32.6014 36.3278 32.5442 36.4627 32.4443 36.5629C32.3444 36.663 32.2096 36.7206 32.0682 36.7235C31.9269 36.7264 31.7898 36.6744 31.6859 36.5785L25.1639 30.0785C25.1129 30.0277 25.0725 29.9674 25.0449 29.901C25.0173 29.8346 25.0031 29.7634 25.0031 29.6915C25.0031 29.6195 25.0173 29.5483 25.0449 29.4819C25.0725 29.4155 25.1129 29.3552 25.1639 29.3045L25.5 29Z" fill="#161616" stroke="#161616" stroke-width="2"/></svg>',
    nextArrow: '<svg class="slick-next slick-arrow" width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 58V1H58V58H1Z" stroke="#161616" stroke-width="2"/><path d="M33.5 29L27.3171 22.7975C27.2132 22.7015 27.0761 22.6496 26.9348 22.6525C26.7934 22.6554 26.6586 22.7129 26.5587 22.8131C26.4588 22.9132 26.4016 23.0481 26.3991 23.1895C26.3965 23.3309 26.4489 23.4678 26.5451 23.5715L32.6791 29.6885L26.5421 35.8045C26.4459 35.9081 26.3935 36.045 26.3961 36.1864C26.3986 36.3278 26.4558 36.4627 26.5557 36.5629C26.6556 36.663 26.7904 36.7206 26.9318 36.7235C27.0731 36.7264 27.2102 36.6744 27.3141 36.5785L33.8361 30.0785C33.8871 30.0277 33.9275 29.9674 33.9551 29.901C33.9827 29.8346 33.9969 29.7634 33.9969 29.6915C33.9969 29.6195 33.9827 29.5483 33.9551 29.4819C33.9275 29.4155 33.8871 29.3552 33.8361 29.3045L33.5 29Z" fill="#161616" stroke="#161616" stroke-width="2"/></svg>',
  });
});



$(document).ready(function(){
	
  $('.abz-tabs .shopify-tabs').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('.abz-tabs .shopify-tabs').removeClass('current');
    $('.abz-tabs-grid').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  })

})


$().ready(function(){
  $('.abz-image-slide').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    arrows: false,
    infinite: true,
     responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 992,
      settings: {
       slidesToShow: 2,
        slidesToScroll: 1,
      }
    }
    ]
  });
});



// init controller
$('.slider-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: '20rem',
  arrows: false,
  touchMove: false,
  draggable: false,
  swipe: false,
  asNavFor: '.slider-nav',
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 1,
        centerPadding: '7rem',
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        centerPadding: '0',
      }
    }
    ]
});


$('.slider-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 4,
  asNavFor: '.slider-for',
  dots: false,
  arrows: false,
  touchMove: false,
  draggable: false,
  swipe: false,
  focusOnSelect: true
});


$().ready(function(){
  $('.slider-animation').slick({
    arrows: false,
    speed: 8000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToShow: 2.5,
        responsive: [
     {
        breakpoint: 1367,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1.5
        }
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 440,
        settings: {
          slidesToShow: 1.2
        }
      }
    ]
  });
});


